import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../../pm-plugins/main';

import { fetchSuggestions } from './api';

/**
 * Fetches the suggestions and updates the plugin state.
 */
export const updateSuggestions = async ({
	api,
	contentAri,
	signal,
}: {
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined;
	contentAri?: string;
	signal?: AbortSignal;
}): Promise<void> => {
	if (!api) {
		return;
	}
	/**
	 * If the contentAri is not provided
	 */
	if (!contentAri) {
		const suggestions = await fetchSuggestions({
			contentAri: '',
			signal,
		});
		api?.core?.actions?.execute(({ tr }) => {
			tr.setMeta(aiSuggestionsPluginKey, {
				action: 'SET_SUGGESTIONS',
				suggestions,
			});
			return tr;
		});
		return;
	}

	const suggestions = await fetchSuggestions({ contentAri, signal });

	api?.core?.actions?.execute(({ tr }) => {
		tr.setMeta(aiSuggestionsPluginKey, {
			action: 'SET_SUGGESTIONS',
			suggestions,
		});
		return tr;
	});
};
